import React, { useEffect, useRef, useState } from "react";
import { database } from "../firebase";

import dayjs from "dayjs";
import AdvancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(AdvancedFormat);

function scaleCoordinates(coords, imgRef) {
  const width = imgRef.current.width;
  const height = imgRef.current.height;

  return coords.map(([name, e]) => {
    const p = e.parameters;
    const d = document.querySelector(`#${name}`).getBoundingClientRect();

    const x = p.centerX ? width / 2 - d.width / 2 : (p.x / 297) * width;
    const y = (p.y / 210) * height - d.height / 2;

    return { x, y };
  });
}

function specialExtras(key, item) {
  switch (key) {
    case 'id': return {
      textAlign: 'right',
      alignSelf: 'end',
      marginLeft: 'auto',
    }

    case 'trainers': return {
      left: '170px'
    }
  }

}

const CertificatePreview = (props) => {
  const imgRef = useRef(null);
  const [paraCoords, setParaCoords] = useState([]);

  const { template, setMeta } = props;

  const transformInput = (key, value, meta) => {
    switch (key) {
      case "id":
        return `ID: ${props.input.date.format("YYYY[Q]Q")}${props.input.trainingId
          }${meta.employee}`;

      case "date":
        return value.format("DD.MM.YYYY");

      default:
        return value?.toString();
    }
  };

  useEffect(() => {
    if (!imgRef.current) return;

    async function fetchData() {
      if (!template?.metadata) return;

      console.log('ID template:', template.metadata.generation);

      const templateRef = database.ref(
        `templates/${template.metadata.generation}`
      );

      const snapshot = await templateRef.get();

      if (snapshot.exists()) {
        const val = snapshot.val();

        setMeta(val);

        const coords = Object.entries(val.items);

        const scaledCoords = scaleCoordinates(coords, imgRef);
        setParaCoords(scaledCoords);
      }
    }

    fetchData();
  }, [template, setMeta]);

  if (!props.template?.url)
    return (
      <div>
        <h1>Seleziona un template per iniziare</h1>
      </div>
    );

  return (
    <div
      style={{
        position: "relative",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        ref={imgRef}
        id="template-image"
        draggable="false"
        alt="Template background"
        src={props.template.url}
      />

      {Object.entries(props.meta.items).map(([key, item], index) => {
        const p = item.parameters;

        switch (item.type) {
          case "div": {
            return (
              <div
                id={key}
                key={key}
                style={{
                  color: p.textColor,
                  fontFamily: p.font,
                  fontSize: `${p.fontSize * 0.95}pt`,
                  top: `${paraCoords[index]?.y - 6}px`,
                  textAlign: p.centerX ? "center" : p.textAlign ?? "left",

                  position: "absolute",
                  ...specialExtras(key, item)
                }}
              >
                {transformInput(key, props.input[key] ?? props.name, props.input.internal ? {
                  id: "0",
                  name: props.name,
                  employee: "NN",
                } : {
                  id: 0,
                  name: props.name,
                  employee: "",
                })}
              </div>
            );
          }

          case "img": {
            return (
              <img
                id={key}
                src={props.input[key]}
                key={key}
                alt={key}
                style={{
                  top: `${paraCoords[index]?.x}px`,
                  left: `${paraCoords[index]?.y}px`,
                  position: "absolute",
                }}
              />
            );
          }

          default: {
            return "";
          }
        }
      })}
    </div>
  );
};

export default CertificatePreview;
